import 'core-js/modules/es.object.assign.js';
import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { Reorder } from 'framer-motion';

var MenuReorder = /*#__PURE__*/forwardRef(function (props, ref) {
  var hasReorder = props.hasReorder,
    children = props.children,
    items = props.items,
    onReorder = props.onReorder,
    rest = __rest(props, ["hasReorder", "children", "items", "onReorder"]);
  if (hasReorder && onReorder && items) {
    return jsx(Reorder.Group, Object.assign({
      as: "div",
      axis: "y",
      onReorder: onReorder,
      values: items
    }, rest, {
      children: children
    }));
  }
  return jsx("div", Object.assign({}, rest, {
    children: children
  }));
});

export { MenuReorder as default };
